var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIconWithRedBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 9.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 9.5,
    stroke: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9253 32.5469C15.4111 32.5469 14.9652 32.3532 14.5875 31.9658C14.2098 31.5785 14.021 31.1211 14.021 30.5938V14.3828H13.8115C13.5418 14.3828 13.3156 14.2889 13.1331 14.101C12.9506 13.9132 12.8594 13.6805 12.8594 13.4028C12.8594 13.1251 12.9506 12.8935 13.1331 12.708C13.3156 12.5225 13.5418 12.4297 13.8115 12.4297H18.3438C18.3438 12.1497 18.435 11.917 18.6175 11.7314C18.8 11.5459 19.0261 11.4531 19.2959 11.4531H24.7041C24.9739 11.4531 25.2 11.5467 25.3825 11.7339C25.565 11.9211 25.6562 12.153 25.6562 12.4297H30.1885C30.4582 12.4297 30.6844 12.5236 30.8669 12.7114C31.0494 12.8993 31.1406 13.132 31.1406 13.4097C31.1406 13.6873 31.0494 13.9189 30.8669 14.1045C30.6844 14.29 30.4582 14.3828 30.1885 14.3828H29.979V30.5938C29.979 31.1211 29.7902 31.5785 29.4125 31.9658C29.0348 32.3532 28.5889 32.5469 28.0747 32.5469H15.9253ZM15.9253 14.3828V30.5938H28.0747V14.3828H15.9253ZM18.7056 27.1562C18.7056 27.4329 18.7971 27.6649 18.9803 27.8521C19.1634 28.0392 19.3903 28.1328 19.6611 28.1328C19.9318 28.1328 20.1576 28.0392 20.3385 27.8521C20.5194 27.6649 20.6099 27.4329 20.6099 27.1562V17.8008C20.6099 17.5241 20.5183 17.2921 20.3351 17.105C20.152 16.9178 19.9251 16.8242 19.6544 16.8242C19.3837 16.8242 19.1578 16.9178 18.9769 17.105C18.796 17.2921 18.7056 17.5241 18.7056 17.8008V27.1562ZM23.3901 27.1562C23.3901 27.4329 23.4817 27.6649 23.6649 27.8521C23.848 28.0392 24.0749 28.1328 24.3456 28.1328C24.6163 28.1328 24.8422 28.0392 25.0231 27.8521C25.204 27.6649 25.2944 27.4329 25.2944 27.1562V17.8008C25.2944 17.5241 25.2029 17.2921 25.0197 17.105C24.8366 16.9178 24.6097 16.8242 24.3389 16.8242C24.0682 16.8242 23.8424 16.9178 23.6615 17.105C23.4806 17.2921 23.3901 17.5241 23.3901 17.8008V27.1562Z",
    fill: "#EE0B0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconWithRedBorder);
export default __webpack_public_path__ + "static/media/deleteIconWithRedBorder.a4f124fc.svg";
export { ForwardRef as ReactComponent };